import * as React from "react";
import { TextField } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useTranslation } from "react-i18next";

/* Reusable component to select time 
Parameters: (useState values)
1) handleTime = function managing the time value
2) dateTime = selected time value
*/

function DatePicker(props: { handlingTime: any; dateTime: Date | null }) {

  const { t } = useTranslation()

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        label={t("Starting time")}
        value={props.dateTime}
        //ampm={true}
        inputFormat={"dd/MM/yyyy HH:mm"}
        onChange={props.handlingTime}
        renderInput={(params)=> <TextField {...params} sx={{width: "100%"}}/>}
        //minDateTime={now}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
